
import { defineComponent, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { Device, Env, JsBridge } from '@loca/mfe-vue3'
import envConfig from '@/utils/envConfig'
import { useRoute } from 'vue-router'
import { getAreaInfo } from '@/apis/user'

const EMPLOYEE_DIFFERENCE_CN = 'CN' // 员工来源：中国
const EMPLOYEE_DIFFERENCE_EU = 'EU' // 员工来源：欧洲

export default defineComponent({
  name: 'ErrorPage',

  setup() {
    const route = useRoute()
    const isError = () => {
      if (route.query.auth) {
        return false
      }
      return true
    }
    const { t } = useI18n()
    const state = reactive({
      loading: false,
      isInternational: Env.isInternational(),
      isEuropaLabor: false,
      isFeishuPC: Device.isFeishuPC(),
      isFeishu: Device.isFeishu(),
      internalDocUrl: 'https://nio.feishu.cn/docs/doccnZvn8oX1K9IZhJmtKubMkng',
      internationalDocUrl:
        'https://nio.feishu.cn/docx/PNpQd7mmRouwqsxE7xhcFRWvnKg',
      isPc: !Device.isMobile(),
      appId: envConfig.APP_ID,
      env: Env.getEnv(),
      // en是国外portal，zh是国内portal
      lang: Env.isInternational() ? 'en' : 'zh',
      config: {
        zh: { // 国内portal
          [EMPLOYEE_DIFFERENCE_CN]: { // 员工来源:CN的人，默认
            local: 'https://laputa-test.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            dev: 'https://laputa-dev.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            test: 'https://laputa-test.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            stg: 'https://laputa-stg.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            prod: 'https://laputa.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID
          }
        },
        en: { // 国外portal
          [EMPLOYEE_DIFFERENCE_EU]: { // 员工来源:eu的人
            local: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=en&app_id='
              + envConfig.APP_ID,
            dev: 'https://laputa-dev-eu.nioint.com/authorityApply.html?lang=en&app_id='
              + envConfig.APP_ID,
            test: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=en&app_id='
              + envConfig.APP_ID,
            stg: 'https://laputa-stg-eu.nioint.com/authorityApply.html?lang=en&app_id='
              + envConfig.APP_ID,
            prod: 'https://laputa-eu.nioint.com/authorityApply.html?lang=en&app_id='
              + envConfig.APP_ID // 语言是英文
          },
          [EMPLOYEE_DIFFERENCE_CN]: { // 员工来源:CN的人，默认。因为权限小
            local: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            dev: 'https://laputa-dev-eu.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            test: 'https://laputa-test-eu.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            stg: 'https://laputa-stg-eu.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID,
            prod: 'https://laputa-eu.nioint.com/authorityApply.html?lang=zh&app_id='
              + envConfig.APP_ID // 语言是中文
          }
        }
      }
    })

    // function applinkActivateDocUrl() {
    //   // 外部浏览器访问的 url
    //   const url = state.isInternational
    //     ? state.internationalDocUrl
    //     : state.internalDocUrl

    //   // 唤起飞书的 applink
    //   let applinkTarget =
    //     'https://applink.feishu.cn/client/web_url/open?mode=window&url='
    //   applinkTarget += encodeURIComponent(url)

    //   return state.isFeishu ? applinkTarget : url
    // }

    async function handleApply() {
      if (state.loading) {
        return
      }
      // 员工来源
      let personDiff = ''
      if (state.isInternational) {
        // 根据员工来源不同，要跳转不同的url
        personDiff = state.isEuropaLabor ? EMPLOYEE_DIFFERENCE_EU : EMPLOYEE_DIFFERENCE_CN
      } else {
        personDiff = EMPLOYEE_DIFFERENCE_CN
      }
      // 取出url的path
      const WfUrl = state.config?.[state.lang]?.[personDiff]?.[state.env]

      JsBridge.openUrl(WfUrl)
    }

    async function isEuropaLabor() {
      state.loading = true
      const res = await getAreaInfo()
      if (res && res.isValid()) {
        if (
          res.data.employeeDifference &&
          res.data.employeeDifference.includes('EU')
        ) {
          state.loading = false
          return true
        }
      }
      state.loading = false
      return false
    }
    async function init () {
      if (state.isInternational) {
        state.isEuropaLabor = await isEuropaLabor()
      }
    }
    init()
    return {
      t,
      state,
      isError,
      // applinkActivateDocUrl,
      handleApply
    }
  }
})
